<template>
  <label class="bx-radio">
    <input
      :value="value"
      :disabled="disabled"
      type="radio"
      :checked="checked"
      @input="onInput"
      ref="input"
    />
    <div class="check"></div>
    <span class="bx-label">
      <slot></slot>
    </span>
  </label>
</template>
<script>
export default {
  name: "bx-radio",
  props: {
    value: {
      default: ""
    },
    nativeValue: {
      type: [String, Number],
      default: "",
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked() {
      return this.value == this.nativeValue;
    }
  },
  methods: {
    onInput() {
      if (this.$refs.input.checked) {
        this.$emit("input", this.nativeValue);
      }
    }
  }
};
</script>
